skrilla.directive('incomeAccessReports',function() {
    return {
        templateUrl: 'directives/affiliates/incomeAccessReports.html',
        scope: {
        },
        controller: function($scope, searchService, queryService, paginationService, srefService){
            $scope.types = ["PROFILE", "BETTING"];
            $scope.key = "incomeAccessReports";
            $scope.reset = function(){
                $scope.query = {limit: 20}
            }
            $scope.reset();

            $scope.search = function(){
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getReports, $scope.key);
            }


            function getReports(){
                return searchService.get(`affiliates/incomeAccessReports${queryService.getQueryString($scope.query, $scope.key)}`).then(function(response){
                    $scope.tableData.data = response.data.result;
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            $scope.tableData = {
                columns: [
                    {title: "Type", field: "type"},
                    {title: "Name", field: "name"},
                    {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}},
                ],
                rows: {style: "cursor: pointer;", onClick: (report, event) => {srefService.go("incomeAccessReportDetails", {id: report.id}, event)}},
                isSkrillaTable: true,
                data: []
            }

        }
    };
});
